import { Box, Divider, Typography } from '@mui/material';
import { ServePreferences } from '../../../../../../Models/Departments/Details/ServePreferences';
import { DepartmentFile } from '../../../../../../Models/Departments/Details/file';
import PatientInfo from './Components/PatientInfo';
import CaseInfo from './Components/CaseInfo';
import DocumentInfo from './Components/DocumentInfo';
import FilesInfo from './Components/FilesInfo';
import { horizontalLine, subPanelHeader } from '../../../../../../assets/styles/appStyles';

export default function ServePreferencesInfo({
  servePreferences,
  files,
}: {
  servePreferences: ServePreferences | undefined;
  files: DepartmentFile[];
}) {
  return (
    <Box mt={2}>
      <Typography sx={subPanelHeader}>Serve Preference</Typography>
      
      <PatientInfo servePreferences={servePreferences}/>
       <Divider sx={horizontalLine} />

      <CaseInfo servePreferences={servePreferences} />
      <Divider sx={horizontalLine} />

      <DocumentInfo servePreferences={servePreferences} />
      <Divider sx={horizontalLine} />

      <FilesInfo files={files} />
    </Box>
  );
}
